import type { ComponentType } from 'react';

import { DownloadOptionsStep } from '../onboarding-step/download-options-step';
import { PersonaUseCaseStep } from '../onboarding-step/persona-use-case-step';
import { WelcomeStep } from '../onboarding-step/welcome-step';

// Personas
export type UseCase = 'work' | 'personal' | 'education';
export type Role =
	| 'Executive'
	| 'Sales'
	| 'Product'
	| 'Support'
	| 'Marketing'
	| 'Design'
	| 'Operations'
	| 'Engineering'
	| 'Customer Success'
	| 'Human Resources';

// Download
export type Recorder = 'extension' | 'windows' | 'intel' | 'apple' | 'none';

// Steps
export type OnboardingStepProps = {
	/**
	 * Primary action for every onboarding screen. The step manager decides
	 * whether that advances to the next step or finishes the flow.
	 */
	onContinue: () => void;
};

export const ONBOARDING_STEPS = [
	'welcome-step',
	'persona-use-case-step',
	'download-options-step',
] as const;
export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

/**
 * Catalog of every onboarding screen. Add a new screen by defining its
 * constant above and mapping it here.
 */
export const ONBOARDING_STEP_COMPONENTS: Record<
	OnboardingStep,
	ComponentType<OnboardingStepProps>
> = {
	['welcome-step']: WelcomeStep,
	['persona-use-case-step']: PersonaUseCaseStep,
	['download-options-step']: DownloadOptionsStep,
} satisfies Record<string, ComponentType<OnboardingStepProps>>;

// Onboarding Data
export type OnboardingData = {
	aaid: string;
	useCase: UseCase;
	role?: Role;
	recorder: Recorder;
};
